import { z } from "zod";

import { map } from "~/tools/map";

import { DEFAULT as DEFAULT_QUERY, type Spec as QuerySpec } from "../components/widget-form/query/spec";
import type { Spec as ChartSpec } from "../components/widget-form/spec";

import { decoder as queryDecoder, encoder as queryEncoder } from "./query/spec";
import { decoder as settingsDecoder, encoder as settingsEncoder } from "./settings/spec";
import { partial, tuple } from "./_decoders";
import { Encoder } from "./_encoder";

interface Spec {
	queries?: ReadonlyArray<QuerySpec>;
	chart?: ChartSpec;
}

const decoder = tuple([
	z
		.array(queryDecoder.optional().catch(undefined))
		.transform(map((query) => query ?? DEFAULT_QUERY))
		.readonly()
		.optional()
		.catch(undefined),

	settingsDecoder,
])
	.transform(([queries, chart]) => partial<Spec>({ queries, chart }))
	.catch(undefined);

function encoder({ queries, chart }: Spec): Encoder {
	return Encoder.tuple(
		Encoder.list(queries, [DEFAULT_QUERY], queryEncoder),

		settingsEncoder(chart),
	);
}

export { decoder, encoder };
export type { Spec };
